if (!customElements.get("reviews-slider")) {
  class reviewsSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.swiper = null;
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.slider = this.querySelector(".reviews-slider__rows");
      this.onResize();
      window.addEventListener("resize", this.onResize);
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.onResize);
      this.destroySlider();
    }

    onResize() {
      const isMobile = window.innerWidth <= 1200;
      
      if (isMobile && !this.swiper) {
        this.initSlider();
      } else if (!isMobile && this.swiper) {
        this.destroySlider();
      }
    }

    initSlider() {
      if(!this.slider) return;

      const autoplayDelay = parseInt(this.slider.dataset.autoplayDelay);
      
      const swiperOptions = {
        slidesPerView: 1.42,
        spaceBetween: 18,
        loop: true,
        grabCursor: true,
      
        breakpoints: {
          767: {
            slidesPerView: 2.5,
            spaceBetween: 25,
          },
        }
      };

      if (autoplayDelay && autoplayDelay > 0) {
        swiperOptions.autoplay = {
          delay: autoplayDelay * 1000,
          disableOnInteraction: false,
        };
      }

      this.swiper = new Swiper(this.slider, swiperOptions);
    }

    destroySlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define("reviews-slider", reviewsSlider);
}
